import { render } from "./vote-card.vue?vue&type=template&id=b9c071cc&scoped=true"
import script from "./vote-card.vue?vue&type=script&lang=js"
export * from "./vote-card.vue?vue&type=script&lang=js"

import "./vote-card.vue?vue&type=style&index=0&id=b9c071cc&lang=scss&scoped=true"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c071cc"]])

export default __exports__